import MetaComponent from "@/components/common/MetaComponent";
import EditCif from "@/components/EditCif.jsx";

const metadata = {
  title: "Homes For Sale | Online Real Estate Auctions | Properties | Hubzu",
};

const EditLayout = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <EditCif />
    </>
  );
};

export default EditLayout;
